export default {"src":"/_next/static/media/Bitter.0b838486.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};